module.exports = __webpack_public_path__ + "img/f-thermometer-img7-1.bfccb4f2.jpg";